import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported once in your app

export default class Galeria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;

    let imagenes = [];
    this.props.imagenes.map((imagen) =>
      imagen.tipo === "jpg"
        ? imagenes.push(
          "http://143.198.191.211/api/securedocs/" +
          imagen.filename +
          "?api_token=" +
          localStorage.api_token
        )
        : null
    );

    return (
      <div>
        <Button
          variant="secondary"
          onClick={() => this.setState({ isOpen: true })}
        >
          Abrir Galeria
        </Button>

        {isOpen && (
          <Lightbox
            className="ligth-box-top"
            mainSrc={imagenes[photoIndex]}
            nextSrc={imagenes[(photoIndex + 1) % imagenes.length]}
            prevSrc={
              imagenes[(photoIndex + imagenes.length - 1) % imagenes.length]
            }
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + imagenes.length - 1) % imagenes.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % imagenes.length,
              })
            }
          />
        )}
      </div>
    );
  }
}
